import styled, { css } from 'styled-components';

import { colors, monokaiBackground, darkModeBackground } from 'global/colors';

export const ApiContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      background-color: ${darkModeBackground};
    `};
`;

export const ApiMethodHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  width: 100%;
  padding: 10px 7px 10px 7px;
  color: ${colors.white};
  background-color: ${colors.fsDarkBlue};
  border-bottom: 1px solid ${colors.fsDarkBlueHoverDark};

  i {
    float: right;
    line-height: 100%;
    transition: transform 0.35s ease-in-out;
  }

  ${({ canOpen }) =>
    canOpen &&
    css`
      cursor: pointer;
      &:hover {
        background-color: ${colors.fsDarkBlueHoverDark};
      }
    `}

  ${({ isOpen }) =>
    isOpen &&
    css`
      background-color: ${colors.fsDarkBlueHoverDark};
      i {
        transform: rotate(180deg);
      }
    `}
`;

export const ApiDescription = styled.p`
  padding: 10px;
  white-space: pre-wrap;
  margin-bottom: 0px;
  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      background-color: ${monokaiBackground};
      color: ${colors.white};
    `}
`;

export const ExpandIcon = styled.i.attrs(({ icon }) => ({
  // icon is a required prop
  className: icon,
}))`
  color: ${colors.white};
  margin-right: 10px;
  /* font-size: 2rem; */
`;
